import { render } from "./GameChatGPTTest.vue?vue&type=template&id=3c38096c&scoped=true"
import script from "./GameChatGPTTest.vue?vue&type=script&lang=js"
export * from "./GameChatGPTTest.vue?vue&type=script&lang=js"

import "./GameChatGPTTest.vue?vue&type=style&index=0&id=3c38096c&lang=scss"
import "./GameChatGPTTest.vue?vue&type=style&index=1&id=3c38096c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c38096c"]])

export default __exports__